document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.getElementById('QuickViewDrawer');
  const body = drawer.querySelector('.drawer-body');
  const closeBtn = drawer.querySelector('.drawer-close');

  document.querySelectorAll('.quick-view-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const handle = btn.dataset.productHandle;
      drawer.classList.add('active');
      body.innerHTML = '<p>Loading product...</p>';

      fetch(`/products/${handle}?view=quick-view`)
        .then(r => r.text())
        .then(html => (body.innerHTML = html))
        .catch(() => (body.innerHTML = '<p>Error loading product.</p>'));
    });
  });

  closeBtn.addEventListener('click', () => drawer.classList.remove('active'));
  drawer.addEventListener('click', e => {
    if (e.target.classList.contains('drawer-overlay')) {
      drawer.classList.remove('active');
    }
  });
});
